// extracted by mini-css-extract-plugin
module.exports = {"subjectCard":"subjectInfoCard_subjectCard__3qxIs","customerNumber":"subjectInfoCard_customerNumber__1iJpP"};